import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AnonymousReportModuleUi } from '@modules/front';
import { Inject } from '@plugin/inversify';
import { AnonymousReportServiceType } from '@service/anonymous-reports';
let AnonymousReportModuleUI = class AnonymousReportModuleUI extends AnonymousReportModuleUi {
    onSubmit(formData) {
        return this.anonymousReportService.submit({
            message: formData.message,
            name: formData.name,
            email: formData.email,
            consent: formData.consent
        });
    }
    onDownloadPgpKey() {
        return this.anonymousReportService.downloadPgpKey();
    }
};
__decorate([
    Inject(AnonymousReportServiceType)
], AnonymousReportModuleUI.prototype, "anonymousReportService", void 0);
AnonymousReportModuleUI = __decorate([
    Component({
        name: 'AnonymousReportModuleUI'
    })
], AnonymousReportModuleUI);
export { AnonymousReportModuleUI };
